import { layout } from "@westpierstudio/luma";
import { SpriteAssetSpec } from "@westpierstudio/luma/factory/PixiFactory";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Sprite } from "pixi.js";
import { ReelsLayout } from "./ReelsModel";

interface ReelsCharactersSpec {
    characters: SpriteAssetSpec
    minHeight: number
}

export class ReelsCharacters extends View {
    protected readonly spec: ReelsCharactersSpec;

    constructor(protected override services: GameServices, protected reelsLayout: ReelsLayout) {
        super(services);

        const { factory, resources, layout } = services;
        this.spec = resources.getSpec(`reelCharacters`) as ReelsCharactersSpec;
        factory.createSprite(this.spec.characters, this);

        this.resize();
        layout.onResize.add(this.resize, this);
    }

    resize() {
        const { layout } = this.services;
        const isPortrait = layout.orientation === `portrait`;
        this.visible = isPortrait && this.spec.minHeight < layout.getScreenBoundaryInBucketSpace().height;
    }
}